import { getAccountService } from './src/account-service';
import { getBulkEditParams } from './src/bulk-edit-params';
import { getBulkEditService } from './src/bulk-edit-service';
import { getGridOptionUtils } from './src/grid-option-utils';

export const getHotelCenterService = ({
  state, jsdata, edm, dataStore,
} = {}) => ({
  ...getAccountService({ state, jsdata, edm }),
  ...getBulkEditParams({ state }),
  ...getBulkEditService({ dataStore }),
  ...getGridOptionUtils({ edm, state }),
});
